import { Check } from "lucide-react";
import { useCurrency } from "@/lib/currency";

export default function GlobalCurrencyPicker() {
  const { displayCurrency } = useCurrency();
  return (
    <div className="inline-flex items-center gap-1.5 h-9 px-3 rounded-full bg-white border border-black/[0.08] text-[12.5px] font-mono font-semibold text-[#1C1C1E] shadow-[0_1px_2px_rgba(0,0,0,0.04)]" title="Indonesian Rupiah">
      <span>{displayCurrency}</span>
      <Check className="w-3.5 h-3.5 text-[#A87552]" />
    </div>
  );
}
